import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"

export const query = graphql`
  fragment ContentfulWistiaItemFragment on ContentfulWistiaItem {
    __typename
    contentful_id
    wistiaHeading
    maxVideosWidth
    videosAlignment
    videos {
      items {
        hashed_id
      }
    }
  }
`

const decodeHtmlEntities = (html) => {
  const textarea = document.createElement("textarea")
  textarea.innerHTML = html
  return textarea.value
}

const WistiaEmbed = ({ hashedId }) => {
  const [embedHtml, setEmbedHtml] = useState("")
  const [title, setTitle] = useState("")

  useEffect(() => {
    fetch(
      `https://fast.wistia.com/oembed?url=https://home.wistia.com/medias/${hashedId}?embedType=async&videoFoam=true`,
    )
      .then((response) => response.json())
      .then((data) => {
        setEmbedHtml(data.html)
        setTitle(data.title ? decodeHtmlEntities(data.title) : "")
      })
      .catch((error) => console.error("Error fetching Wistia oEmbed:", error))
  }, [hashedId])
  return (
    <div>
      <div>{embedHtml ? <div dangerouslySetInnerHTML={{ __html: embedHtml }} /> : <p>Loading video...</p>}</div>
      {title ? <p>{title}</p> : <></>}
    </div>
  )
}

export default WistiaEmbed
